import React from 'react';
const labelsConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/apps/labels',
            component: React.lazy(() => import('../../company-profile/customerAccountDetails/SideNavigationPages/labels/Label'))
        },
        
    ]
};
export default labelsConfig;
